import React from 'react'
import { observer } from 'mobx-react'
import { WorkspacePostingForm } from '../WorkspacePostingDialog'
import UpdateWorkspacePostingViewModel from './UpdateWorkspacePostingViewModel'

interface UpdateWorkspacePostingDialogProps {
  vm: UpdateWorkspacePostingViewModel
}

export default observer(function UpdateWorkspacePostingDialog({
  vm,
}: UpdateWorkspacePostingDialogProps) {
  return (
    <WorkspacePostingForm vm={vm} title="Edit post" buttonText="Save Changes" />
  )
})
